// extracted by mini-css-extract-plugin
export default {"itemsContainer":"CoffeeCupReading_itemsContainer__ptrpY","itemContainer":"CoffeeCupReading_itemContainer__ITFQJ","selectedItem":"CoffeeCupReading_selectedItem__rCLQm"};